/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateMemberRolesForm = {
  /**
   * The role IDs to assign. Replaces all existing role assignments.
   */
  roleIds: Array<string>;
  /**
   * The user ID to update.
   */
  userId: string;
};

/** @internal */
export type UpdateMemberRolesForm$Outbound = {
  role_ids: Array<string>;
  user_id: string;
};

/** @internal */
export const UpdateMemberRolesForm$outboundSchema: z.ZodMiniType<
  UpdateMemberRolesForm$Outbound,
  UpdateMemberRolesForm
> = z.pipe(
  z.object({
    roleIds: z.array(z.string()),
    userId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      roleIds: "role_ids",
      userId: "user_id",
    });
  }),
);

export function updateMemberRolesFormToJSON(
  updateMemberRolesForm: UpdateMemberRolesForm,
): string {
  return JSON.stringify(
    UpdateMemberRolesForm$outboundSchema.parse(updateMemberRolesForm),
  );
}
